(() => {
  const publish = (name, payload = {}) => {
    const details = Object.assign({
      page_type: window.meta?.page?.pageType || document.body?.dataset?.template || '',
      path: window.location.pathname
    }, payload);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, details));

    try {
      window.Shopify?.analytics?.publish?.(name, details);
    } catch (error) {
      // Custom pixel subscribers are optional. Shopify's native funnel still measures checkout conversion.
    }
  };

  document.addEventListener('change', (event) => {
    const zip = event.target.closest?.('[data-fm-delivery-zip]');
    if (!zip) return;
    const value = String(zip.value || '').replace(/\D/g, '').slice(0, 5);
    if (/^\d{5}$/.test(value)) publish('fm_zip_entered');
  });

  document.addEventListener('click', (event) => {
    const filter = event.target.closest?.('[data-fm-filter-link], .fm-filter-chip a');
    if (filter) {
      const wrapper = filter.closest('[data-fm-filter-group]') || filter;
      publish('fm_filter_used', {
        filter_group: wrapper.dataset.fmFilterGroup || '',
        filter_value: wrapper.dataset.fmFilterValue || filter.textContent.trim()
      });
    }

  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form.id === 'FMCartForm' && event.submitter?.name === 'checkout') {
      queueMicrotask(() => {
        if (!event.defaultPrevented) publish('fm_begin_checkout', { cart_page: true });
      });
    }
    if (form.matches?.('[data-fm-native-filter-form]')) {
      publish('fm_filter_apply', { filter_group: 'native' });
    }

    if (form.matches?.('form[action*="/cart/add"]')) {
      publish('fm_product_order_submit', {
        variant_id: form.querySelector('[name="id"]')?.value || ''
      });
    }
  });
})();